import React, { Component } from 'react';
import { message, Select } from 'antd';
import { queryBudgetGroupList } from '@api/finance/budget';

const { Option } = Select;

class Group extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyAll: [],
    };
  }

  componentDidMount() {
    this.getGroupList();
  }

  // 设置预算组下拉菜单
  formatOption = arr => {
    const { companyAll } = this.state;
    arr.map(item => {
      if (item.children && item.children.length > 0) {
        this.formatOption(item.children);
      }
      companyAll.push(item);
      return item;
    });
    this.setState({
      companyAll,
    });
  };

  // 递归删除空的children
  formatGroup = arr => {
    arr.map(item => {
      if (item.children) {
        if (item.children.length === 0) {
          delete item.children;
          return item;
        }
        if (item.children.length > 0) {
          this.formatGroup(item.children);
        }
      }
      return item;
    });
    return arr;
  };

  // 预算组列表
  getGroupList = async () => {
    let groupList = [];
    await queryBudgetGroupList({ isEnable: 1 }).then(res => {
      if (res.statusCode === 200) {
        groupList = this.formatGroup(res.data);
      } else {
        message.error(res.message);
      }
    });

    this.formatOption(groupList);
  };

  change = value => {
    const { companyAll } = this.state;
    const groupUuid = value;
    let groupName = '';
    companyAll.map(item => {
      if (value === item.uuid) {
        groupName = item.name;
      }
      return 1;
    });
    this.props.onChange({ groupUuid, groupName });
  };

  render() {
    const { defaultValue } = this.props;
    if (defaultValue) {
      return (
        <Select
          mode={this.props.mode}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          style={{ width: '100%' }}
          onChange={this.change}
          defaultValue={defaultValue}
        >
          {this.state.companyAll.map(item => {
            return <Option key={item.uuid}>{item.name}</Option>;
          })}
        </Select>
      );
    }
    return (
      <Select
        mode={this.props.mode}
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        style={{ width: '100%' }}
        onChange={this.change}
      >
        {this.state.companyAll.map(item => {
          return (
            <Option key={item.uuid} value={item.uuid}>
              {item.name}
            </Option>
          );
        })}
      </Select>
    );
  }
}

export default Group;



// WEBPACK FOOTER //
// ./src/components/comm/chooseGroup.js